import React from 'react'

interface CardProps {
    children: React.ReactNode
    className?: string
    title?: string
    description?: string
    action?: React.ReactNode
    style?: React.CSSProperties
    onClick?: () => void
    compact?: boolean
}

export const Card: React.FC<CardProps> = ({ children, className = '', title, description, action, style, onClick, compact = false }) => {
    const innerPadding = compact ? 'p-4' : 'p-6'
    return (
        <div
            className={`bg-white rounded-xl border border-slate-200 shadow-sm ${className}`}
            style={style}
            onClick={onClick}
        >
            {(title || action) && (
                <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
                    <div>
                        {title && <h3 className="font-semibold text-slate-900">{title}</h3>}
                        {description && <p className="text-sm text-slate-500 mt-1">{description}</p>}
                    </div>
                    {action && <div>{action}</div>}
                </div>
            )}
            <div className={innerPadding}>
                {children}
            </div>
        </div>
    )
}
